<template>
  <v-col
    v-if="enabled"
    :cols="cols"
    :lg="lg"
    :md="md"
  >
    <v-row dense>
      <v-col
        v-if="label"
        class="labeled-input"
        cols="12"
      >
        <span>{{ $bct(label) }}</span>

        <RequiredIndicator v-if="mandatory" />
      </v-col>

      <template v-if="description">
        <v-col
          class="fs-16 c-light-black my-1"
          cols="12"
        >
          <span>{{ $bct(description) }}</span>
        </v-col>
      </template>

      <v-col>
        <v-checkbox
          @update:model-value="handleUpdateModelValue"
          ref="check_box"
          :append-inner-icon="appendIcon"
          :class="computedClass"
          :density="dense ? 'compact' : undefined"
          :disabled="locked"
          :label="checkboxText"
          :model-value="localValue"
          data-testid="labeled-checkbox"
          false-icon="check_box_outline_blank"
          true-icon="check_box"
          variant="filled"
          hide-details
          tile
          v-bind="filteredAttrs"
        />
      </v-col>
    </v-row>
  </v-col>
</template>

<script setup>
import attrsOmitDataPrefix from '@/shared/utils/filteredAttrs';
import propsToRefs from '@/shared/utils/propsToRefs';
import RequiredIndicator from '@/shared/components/RequiredIndicator.vue';
import useLabeledField from '@/shared/composables/useLabeledField';
import useSchematizedField from '@/shared/composables/useSchematizedField';
import { onUpdated } from 'vue';

defineEmits(useLabeledField.emits);

const $bct = inject('translator');

const localValue = defineModel({ type: Boolean, required: true });

const props = defineProps({
  checkboxText: {
    type: String,
    default: null,
  },
  description: {
    type: String,
    default: null,
  },
  ...useLabeledField.props,
  ...useSchematizedField.props,
});

const { appendIcon, handleUpdateModelValue } = useLabeledField(
  ...propsToRefs(props, useLabeledField.paramKeys),
);

const { enabled, label, locked } = useSchematizedField(
  ...propsToRefs(props, useSchematizedField.paramKeys),
);

const computedClass = computed(() => {
  if (props.dense) return [];
  return ['mt-2'];
});

const attrs = useAttrs();
const filteredAttrs = ref(attrsOmitDataPrefix(attrs));

onUpdated(() => {
  filteredAttrs.value = attrsOmitDataPrefix(attrs);
});
</script>
